<template>

    <timeline :items="students" @click="viewStudent" :isActive="isStudentActive" class="sidebar__content--students timeline--students">

        <template slot="item" scope="student">
            <div class="timeline__hoverable">
                <header class="timeline__header">
                    <h3 class="timeline__title">
                        <span class="mini-visible">{{ initials(student) }}</span>
                        <span class="mini-hidden">{{ username(student) }}</span>
                    </h3>
                </header>
            </div>
        </template>

        <template slot="empty">
            Geen leerlingen gevonden
        </template>

    </timeline>

</template>


<script>

import Timeline from 'js/admin/components/sidebar/Timeline.vue'
import { username, initials } from 'js/helpers/transformers'

export default {
    props: {
        group: {}
    },

    components: { Timeline },

    computed: {
        students: function() {
            return this.group.students.map( id => this.$store.state.users.storage[id] )
        },
    },
    methods: {
        isStudentActive: function(student) {
            return this.$route.params.studentId === student.id
        },
        viewStudent: function(student) {
            this.$router.push({ name: 'students.period', params: { studentId: student.id }})
        },
        username,
        initials,
    }
}
</script>



<style lang="scss">

    @import 'global';

    .timeline--students {

        .timeline {
            &__item {
                padding-left: 6px;
                padding-bottom: 0;
                &:before {
                    content: none;
                }
            }
        }

    }

</style>



// WEBPACK FOOTER //
// SidebarContentStudents.vue?67401737